<template>
  <div class="budgets-layout container">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "BudgetsLayout"
}
</script>

<style scoped lang="scss">
.budgets-layout {
  margin-top: 7px;
  display: grid;
  grid-template-columns:418px 300px;
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
  padding-bottom: 80px;
  @media(min-width: 1200px) {
    grid-template-columns:670px 470px;
    grid-column-gap: 3rem;
    grid-row-gap: 3rem;
  }
}
</style>